import React from 'react'

// icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/free-solid-svg-icons'

// routes
import { withRouter } from 'react-router-dom'

// Sweet alert
import Swal from 'sweetalert2'

// services
import { recoverSucursalDeleted } from '../../Services/sucursalService'

const ItemSucursalEliminados = ({ sucursal, history, setIsLoad }) => {
    const recoverSucursalSubmit = (sucursal) => {
        Swal.fire({
            title: 'Estas seguro de recuperarlo?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, Recuperar!',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.value) {
                // consulta a la api para eliminar
                recoverSucursalDeleted(sucursal.id)
                    .then((res) => {
                        Swal.fire(
                            'Recuperado!',
                            'La sucursal fue recuperado.',
                            'success'
                        )
                        setIsLoad(true)
                    })
                    .catch((error) => {
                        Swal.fire({
                            type: 'error',
                            title: 'Error',
                            text: 'Hubo un error vuelve a intentar!',
                        })
                        console.log(error.response)
                    })
            }
        })
    }

    return (
        <tr>
            <th scope="row">{sucursal.id}</th>
            <td>{sucursal.nombre}</td>
            <td>{sucursal.direccion}</td>
            <td>{sucursal.telefono}</td>
            <td>
                <button
                    className="btn text-warning"
                    onClick={() => {
                        recoverSucursalSubmit(sucursal)
                    }}
                >
                    <FontAwesomeIcon icon={faTrash} /> Recuperar
                </button>
            </td>
        </tr>
    )
}

export default withRouter(ItemSucursalEliminados)
